<template>
    <div class="information">
        <el-form
            :model="ruleForm"
            ref="ruleForm"
            label-width="100px"
            style="overflow: hidden;"
        >
            <el-col :span="5">
                <el-form-item label="审批状态" prop="Approval_status">
                    <el-select v-model="ruleForm.Approval_status" placeholder="请选择">
                        <el-option
                            v-for="item in Approval_statusList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="5">
                <el-form-item label="开始日期" prop="starttime">
                    <el-date-picker
                            class="width1"
                            v-model="ruleForm.starttime"
                            type="date"
                            placeholder="选择开始日期"
                            @change="startDate"
                    ></el-date-picker>
                </el-form-item>
            </el-col>
            <el-col :span="5">
                <el-form-item label="结束日期" prop="Jieshutime">
                    <el-date-picker
                            class="width1"
                            v-model="ruleForm.endtime"
                            type="date"
                            placeholder="选择结束日期"
                            @change="endDate"
                    ></el-date-picker>
                </el-form-item>
            </el-col>
            <el-col :span="8">
                <el-form-item prop="searchInput" class="search">
                    <el-input v-model="ruleForm.searchInput" placeholder="全字段搜索" style="width: 70%;"></el-input>
                    <el-button type="primary" @click="search2" style="margin-left:20px;">搜索</el-button>
                    <el-button type="primary" @click="resetFprm">重置</el-button>
                </el-form-item>
            </el-col>
        </el-form>
        
        <el-table :data="tableData" border style="width: 100%">
            <el-table-column prop="applyRoleName" label="申请人" align="center"></el-table-column>
            <el-table-column prop="receiptNumber" label="单据号" align="center"></el-table-column>
            <el-table-column prop="receiptMoney" label="审批金额" align="center"></el-table-column>
            <el-table-column prop="receiptBalance" label="当前余额" align="center"></el-table-column>
            <el-table-column label="凭证图片" align="center" width="89">
                <template slot-scope="scope" class="img">
                    <el-popover trigger="hover">
                        <img :src="scope.row.approveImageUrl" class="prduct_img" alt />
                        <div class="scope_img" slot="reference">
                            <img :src="scope.row.approveImageUrl" alt />
                        </div>
                    </el-popover>
                </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注" align="center"></el-table-column>
            <el-table-column prop="approveRoleName" label="操作员" align="center"></el-table-column>
            <el-table-column prop="createTime" label="申请日期" align="center"></el-table-column>
            <el-table-column prop="updateTime" label="更新日期" align="center"></el-table-column>
            <el-table-column label="操作" fixed="right" width="240" align="center">
                <template slot-scope="scope">
                    <el-button type="primary" @click="adopt(scope.row)" v-if="scope.row.status == 1">审批通过</el-button>
                    <el-button type="danger" @click="No_pass(scope.row)" v-if="scope.row.status == 1">不予通过</el-button>
                    <span v-if="scope.row.status == 2">审批通过</span>
                    <span v-if="scope.row.status == 3">不予通过</span>
                </template>
            </el-table-column>
        </el-table>
        <div class="page">
            <el-pagination
                style="margin-top: 16px; text-align:center;"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[100, 200, 300, 400]"
                :page-size="100"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
            ></el-pagination>
        </div>

        <el-dialog title="审批" :visible.sync="credentials" width="25%">
            <div style="margin:20px;">添加凭证</div>
            <div>
                <el-upload
                    ref='upload'
                    class="avatar-uploader"
                    :action="action"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :headers="customHeaders"
                    >
                    <img v-if="imageUrl" :src="imageUrl" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="credentials = false">取 消</el-button>
                <el-button type="primary" @click="Addcredentials">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
import { ajaxPost, Baseurl } from "../../api/api/api";
export default {
    name: "Procurement_approval",
    data() {
        return {
            dialogVisible: false,
            dialogImageUrl: "",

            currentPage: 1,
            pagesize: 50,
            size: 50,
            total: 0,
            
            credentials:false,
            dialogVisible:false,
            action: Baseurl + "imageController/uploadImage",
            customHeaders: { token: localStorage.getItem("token") },
            imageUrl: '',
            value:"",

            ruleForm: {
                Approval_status: "", //审批状态
                starttime: "", //开始时间
                endtime: "", //结束时间
                searchInput: "", //全字段搜索
            },
            Approval_statusList: [
                {
                    value: "1",
                    label: "未审批",
                },
                {
                    value: "2",
                    label: "审批通过",
                },
                {
                    value: "3",
                    label: "不予通过",
                },
            ],
            tableData: [],
        };
    },
    mounted() {},
    created() {
        this.str = JSON.parse(localStorage.getItem("role"));
        this.search()
    },
    methods: {
        search2(){
            this.currentPage = 1
            this.search()
        },
        search() {
            var obj = {
                companyId: this.str.company_id,
                startTimeString:this.ruleForm.starttime,
                endTimeString:this.ruleForm.endtime,
                searchString:this.ruleForm.searchInput,
                status:this.ruleForm.Approval_status,
                page:this.currentPage,
                size:this.size
            };
            ajaxPost(Baseurl + "reserveFundController/getReserveFundApplyListByCompanyId",obj).then(res => {
                if(res.data.code == 200){
                    this.tableData = res.data.data.list;
                    this.total = res.data.data.total;
                    // console.log(res.data)
                }
            });
        },
        handleAvatarSuccess(res, file) {
            this.imageUrl = [res.data];
        },
        adopt(val) {
            this.credentials = true
            this.value = val
        },
        Addcredentials(){
            var obj = {
                id:this.value.id,
                approveImageUrlList:this.imageUrl,
                status:2,
                approveRoleId:this.str.rid
            }
            console.log(obj)
            ajaxPost(Baseurl + "reserveFundController/updateReserveFundApplyStatus",obj).then(res => {
                if(res.data.code == 200){
                    this.$message({
                        message: "审批通过",
                        type: "success"
                    });
                    this.search();
                }else{
                    this.$message.error(res.data.data);
                }
            });
            this.imageUrl = ''
            this.$refs.upload.clearFiles();
            this.credentials = false
        },
        No_pass(val) {
            var obj = {
                id:val.id,
                status:3,
                approveRoleId:this.str.rid
            }
            ajaxPost(Baseurl + "reserveFundController/updateReserveFundApplyStatus",obj).then(res => {
                if(res.data.code == 200){
                    this.$message({
                        message: "不予通过",
                        type: "success"
                    });
                    this.search();
                }else{
                    this.$message.error(res.data.data);
                }
            });
        },
        resetFprm(){
            this.currentPage = 1
            this.ruleForm.Approval_status = ""
            this.ruleForm.searchInput = ""
            this.ruleForm.endtime = ""
            this.ruleForm.starttime = ""
            this.search()
        },
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
            this.size = val;
            this.search()
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            this.currentPage = val;
            this.search()
        },
        //选择开始日期
        startDate(val) {
            var d = new Date(val);
            var datetime =
                d.getFullYear() +
                "-" +
                (d.getMonth() + 1) +
                "-" +
                d.getDate() +
                " 00:00:00";
            this.ruleForm.starttime = datetime;
            console.log(this.ruleForm.starttime);
        },
        //选择结束日期
        endDate(val) {
            var d = new Date(val);
            var datetime =
                d.getFullYear() +
                "-" +
                (d.getMonth() + 1) +
                "-" +
                d.getDate() +
                " 23:59:59";
            this.ruleForm.endtime = datetime;
            console.log(this.ruleForm.endtime);
        },
    },
};
</script>

<style lang="scss" scoped>
/deep/ {
    .el-dialog__body {
        padding: 0px 20px;
    }
    .search .el-form-item__content{
        margin-left: 40px!important;
    }
    .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
}
.information {
    width: 98%;
    overflow: hidden;
}
.scope_img {
    width: 65px;
    height: 65px;
    img {
        width: 100%;
        height: 100%;
    }
}
.prduct_img {
    width: 500px;
    height: 500px;
}
.padding {
    padding: 25px 0;
}
.img{
    display: flex;
    align-items: center;
    justify-content: center;
}
.page {
    position: fixed;
    width: 85%;
    bottom: 0;
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
    line-height: 50px;
}
</style>
